import * as React from "react"
import styled from "styled-components"
export const StyledMessageInputInnerMessage = styled.div<{ level: "info" | "warning" }>`
    padding: ${p => p.theme.spacing(0, 1, 0.5, 1)};
    display:flex;
    gap:${p => p.theme.spacing(0.5)};
    font-family: ${p => p.theme.typography.body2.fontFamily};
    font-size: ${p => p.theme.typography.body2.fontSize};
    font-weight: ${p => p.theme.typography.body2.fontWeight};
    color: ${p => p.level === "info"
        ? p.theme.palette.text.secondary
        : p.theme.palette.warning.main
    };
    align-items:center;
`
export const MessageInputInnerMessage: React.FC<{ level: "info" | "warning" }> = props => {
    return <StyledMessageInputInnerMessage level={props.level}>
        <span>
            {props.children}
        </span>
    </StyledMessageInputInnerMessage>
}